var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.22,
    height: 17.219,
    viewBox: "0 0 17.22 17.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "ai-assistant-icon",
    d: "M13.658,8.61v4.3a.717.717,0,1,1-1.435,0V8.61a.717.717,0,1,1,1.435,0ZM8.334,4.819l2.2,7.913a.71.71,0,0,1-1.367.383l-.461-1.636H4.974l-.461,1.636a.709.709,0,0,1-.683.517h0a.71.71,0,0,1-.684-.9l2.218-7.97a1.515,1.515,0,0,1,.788-1.008A1.512,1.512,0,0,1,8.335,4.82ZM8.3,10.044l-1.384-4.9a.081.081,0,0,0-.157,0l-1.384,4.9Zm8.224-2.87a.718.718,0,0,0-.717.717v5.74a2.155,2.155,0,0,1-2.152,2.152H3.613a2.155,2.155,0,0,1-2.152-2.152V3.587A2.155,2.155,0,0,1,3.613,1.435h5.74A.717.717,0,0,0,9.353,0H3.613A3.591,3.591,0,0,0,.026,3.587V13.632a3.591,3.591,0,0,0,3.587,3.587H13.658a3.591,3.591,0,0,0,3.587-3.587V7.892a.718.718,0,0,0-.717-.717ZM11.614,3.716l1.34.565.535,1.338a.763.763,0,0,0,1.416,0l.532-1.33,1.33-.532a.763.763,0,0,0,0-1.416l-1.33-.532L14.9.479a.763.763,0,0,0-1.417,0L12.959,1.8l-1.32.5a.762.762,0,0,0-.026,1.416Z",
    transform: "translate(-0.026)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantIcon);
export default __webpack_public_path__ + "static/media/ai-assistant-icon.55fae2b0bce109d378a072d9a68379f3.svg";
export { ForwardRef as ReactComponent };